import styled from 'styled-components/macro'
import palette from '../../designSystem/variables/palette'

export const BannerWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1200;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 24px;
  background: ${palette.neutral[700]};
  color: ${palette.neutral.white};
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.12);
`

export const BannerText = styled.p`
  margin: 0;
  font-size: 14px;
  flex: 1;
`

export const BannerLink = styled.a`
  color: ${palette.blue[100]};
  text-decoration: underline;
  margin: 0 4px;

  &:visited {
    color: ${palette.blue[100]};
  }
`

export const BannerButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  flex-shrink: 0;
`

export const BannerButton = styled.button`
  padding: 4px 14px;
  border-radius: 999px;
  border: 1px solid ${palette.neutral.white};
  background: transparent;
  color: ${palette.neutral.white};
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;

  &:hover {
    background: ${palette.neutral[600]};
  }
`
